import { Action } from './actions';

export function isFetchingReducer(state: boolean = false, action: Action): boolean {
  switch (action.type) {
    case 'IFetchStarted':
      return true;
    case 'IFetchFinished':
      return false;
    default:
      return state;
  }
}
